export default new URL("../images/places/place-2.jpg", import.meta.url).href;